import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "flex flex-col items-center gap-0.5 text-center"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
export default {
  __name: 's-info-card',
  props: {
    title: String,
    subtitle: String,
    icon: String,
    success: Boolean
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["w-fit flex flex-col items-center gap-3 bg-main-50/5 text-main-50 rounded-xl p-5 mx-auto animate-fade", {
          'bg-second-100/20 text-second-5!': props.success
        }])
      }, [props.icon ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: _normalizeClass([props.icon, "relative flex items-center justify-center"])
      }, null, 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [props.title ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        innerHTML: props.title
      }, null, 8, _hoisted_2)) : _createCommentVNode("", true), props.subtitle ? (_openBlock(), _createElementBlock("p", {
        key: 1,
        class: "text-xs text-main-50",
        innerHTML: props.subtitle
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true)])], 2);
    };
  }
};